import { FundriseRouteConfig } from 'vue-router';

const shareholderVoteRoutes: Array<FundriseRouteConfig> = [
	{
		path: '/shareholder-vote',
		name: 'shareholder-vote',
		meta: { minTokenScopeRequired: 'FULL_ACCESS' },
		component: () => import('@views/shareholder-vote/shareholder-vote.vue'),
		redirect: { name: 'shareholder-vote-by-account-and-fund' },
		children: [
			{
				path: 'vote-by-fund',
				name: 'shareholder-vote-by-account-and-fund',
				meta: { minTokenScopeRequired: 'FULL_ACCESS' },
				component: () => import('@views/shareholder-vote/shareholder-vote-by-account-and-fund.vue')
			},
			{
				path: 'success',
				name: 'shareholder-vote-success',
				meta: { minTokenScopeRequired: 'FULL_ACCESS' },
				component: () => import('@views/shareholder-vote/shareholder-vote-success.vue')
			},
			{
				path: 'learn-more',
				name: 'shareholder-vote-learn-more',
				meta: { minTokenScopeRequired: 'FULL_ACCESS' },
				redirect: { name: 'shareholder-vote' }
			}
		]
	},
	{
		path: '/webview/shareholder-vote',
		name: 'shareholder-vote-webview',
		meta: { minTokenScopeRequired: 'FULL_ACCESS' },
		component: () => import('@views/webview/shareholder-vote/shareholder-vote.vue'),
		redirect: { name: 'shareholder-vote-by-account-and-fund-webview' },
		children: [
			{
				path: 'vote-by-fund',
				name: 'shareholder-vote-by-account-and-fund-webview',
				meta: { minTokenScopeRequired: 'FULL_ACCESS' },
				component: () => import('@views/shareholder-vote/shareholder-vote-by-account-and-fund.vue')
			},
			{
				path: 'success',
				name: 'shareholder-vote-success-webview',
				meta: { minTokenScopeRequired: 'FULL_ACCESS' },
				component: () => import('@views/shareholder-vote/shareholder-vote-success.vue')
			},
			{
				path: 'learn-more',
				name: 'shareholder-vote-learn-more-webview',
				meta: { minTokenScopeRequired: 'FULL_ACCESS' },
				redirect: { name: 'shareholder-vote-webview' }
			}
		]
	}
];

export default shareholderVoteRoutes;
